import ChooseClient from "@crm/components/search/choose-client";
import {
  V2Dialog,
  DialogContent,
  VisuallyHidden,
  DialogTitle,
  DialogDescription,
} from "web-design-system";
import { Route } from "@/routes/__root";
import { useRouter, useSearch } from "@tanstack/react-router";
import omit from "lodash/omit";
import TransactionWizard from "./transaction-wizard";

export type TransactionDialogActions = "create" | "edit" | "view";

export default function TransactionDialog() {
  const router = useRouter();

  const { client_id = 0 } = useSearch({ from: Route.id });

  let content;

  if (client_id) {
    content = <TransactionWizard />;
  } else {
    content = (
      <ChooseClient
        onSelect={(selectedClient) => {
          router.navigate({
            to: ".",
            search: (prev: Record<string, unknown>) => {
              return { ...prev, client_id: selectedClient.id };
            },
            replace: true,
          });
        }}
      />
    );
  }

  const handleOpenChange = (open: boolean) => {
    if (open) return;
    if (router.history.canGoBack()) {
      router.history.back();
    } else {
      router.navigate({
        to: ".",
        search: (prev: Record<string, unknown>) =>
          omit(prev, [
            "modal",
            "client_id",
            "type",
            "isin",
            "action",
            "folio_id",
            "collection_id",
            "collection_type",
            "collection_target",
          ]),
        replace: true,
      });
    }
  };

  return (
    <V2Dialog open onOpenChange={handleOpenChange}>
      <DialogContent className="min-w-none max-w-none p-0 h-125 md:h-150 xl:h-180 max-h-[85vh] w-auto">
        <VisuallyHidden>
          <DialogTitle>Create Transaction</DialogTitle>
          <DialogDescription>Create transactions for client</DialogDescription>
        </VisuallyHidden>
        {content}
      </DialogContent>
    </V2Dialog>
  );
}
